import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

//Material UI Core Components
import TableHeaderButton from "UI/Table/TableHeaderButton";

//Material UI Icons
import CloudDownloadSharpIcon from "@material-ui/icons/CloudDownloadSharp";

//Custom Components
import { exportTableToExcel } from "Lib/exportExcel";

function TableHeaderButtonExport(props) {
  const { t } = useTranslation();
  const { dc, rows, records, tableName, ...otherProps } = props;

  const handleExport = function (evt) {
    let filteredRecords = new Array();
    for (let i = 0; i < rows.length; i++) {
      filteredRecords.push(records[parseInt(rows[i].id)]);
    }

    const fields = dc.getViewFields("exportExcel");
    const obj = {
      records: filteredRecords,
      fields: fields,
      filename: tableName,
      t: t
    };
    exportTableToExcel(obj);
  };

  return (
      <TableHeaderButton onClick={handleExport} icon={<CloudDownloadSharpIcon />} variant="outlined" {...otherProps}>
        {t("buttons.export")}
      </TableHeaderButton>
  );
}

TableHeaderButtonExport.propTypes = {
  dc: PropTypes.object,
  rows: PropTypes.array,
  records: PropTypes.array,
  fileName: PropTypes.string
};

export default TableHeaderButtonExport;
